import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const BENEFITS = [{
  title: 'Diseño profesional',
  description: 'Cada recurso con estándar de estudio, listo para tu marca.'
}, {
  title: 'Estrategias listas para usar',
  description: 'Guiones y embudos probados que solo tenés que aplicar.'
}, {
  title: 'Marketing basado en IA',
  description: 'Prompts y automatizaciones que multiplican tu producción.'
}, {
  title: 'Recursos descargables',
  description: 'Acceso inmediato en formatos editables y compatibles.'
}, {
  title: 'Fácil implementación',
  description: 'Instrucciones claras para lanzar en menos de una semana.'
}, {
  title: 'Actualizaciones constantes',
  description: 'Mejoras y nuevos módulos incluidos sin costo extra.'
}];
export function Benefits() {
  return <section className="relative w-full border-t border-ink/[0.07] bg-white py-28 sm:py-32 lg:py-40" data-id="element-11" data-mp="1b0hxp9lxsut7">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-12" data-mp="2rg03jygzyoc">
        <div className="max-w-2xl" data-id="element-13" data-mp="2pwm600adzpq">
          <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-14" data-mp="6sjioe7wk8t9">
            Beneficios
          </p>
          <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[2.6rem]" data-id="element-15" data-mp="3ozpp3f4h20dp">
            Todo pensado para que implementes rápido.
          </h2>
        </div>

        <ul className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-4xl border border-ink/[0.07] bg-ink/[0.07] sm:grid-cols-2 lg:mt-20 lg:grid-cols-3" data-id="element-16" data-mp="liqrs3c0sfha">
          {BENEFITS.map((benefit, i) => <motion.li key={benefit.title} initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.05
        }} className="group bg-white p-9 transition-colors duration-300 hover:bg-paper-alt sm:p-10" data-id="element-17" data-mp="br34memhxklm" data-mpi={i}>
              <span className="grid h-8 w-8 place-items-center rounded-full brand-gradient-bg" data-id="element-18" data-mp="1j3igol2qerm0">
                <CheckIcon aria-hidden="true" className="h-4 w-4 text-white" strokeWidth={2.5} data-id="element-19" data-mp="1e3w48duq9fe9" />
              </span>
              <h3 className="mt-6 text-[15.5px] font-semibold tracking-tight text-ink" data-id="element-20" data-mp="153r5es3lnpbp">
                {benefit.title}
              </h3>
              <p className="mt-3 text-[13.5px] font-light leading-relaxed text-ink-muted" data-id="element-21" data-mp="105640pcm2zlo">
                {benefit.description}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}